import { Injectable } from '@angular/core';

import { BaseSignalStore } from '../signal-state.util';

export interface CommonUnitTypeState {
  data: any;
}

const createInitialState = (): CommonUnitTypeState => ({
  data: {}
});

@Injectable({ providedIn: 'root' })
export class CommonUnitTypeStore extends BaseSignalStore<CommonUnitTypeState> {
  constructor() {
    super(createInitialState(), { name: 'common_unit_type' });
  }

  resetStoreData(): void {
    this.reset();
  }
}
